// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__hCqMB","right":"Footer_right__-uUdW","buttons":"Footer_buttons__3l67Q"};